import { baseArkhaleAPI } from './base-api'
import { Notification } from '../../shared/models/notification.model'
import { Pagination } from '../../shared/models/others/pagination'
import { formatSortOrder, PaginationWithSearchTerm } from './query-type'
import { NotificationID } from '../../shared/models/id/notification_id'

const notificationApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => {
    return {
      getNotifications: build.query<
        Pagination<Notification>,
        { status?: 'READ' | 'SENT' } & PaginationWithSearchTerm
      >({
        query: (arg) => ({
          url: '/notifications',
          method: 'GET',
          params: {
            ...arg,
            ...formatSortOrder(arg.sortOrder),
          },
        }),
        providesTags: (result = new Pagination<Notification>()) => [
          { type: 'Notification', id: 'LIST' },
        ],
      }),
      getNotification: build.query<Notification, NotificationID>({
        query: (arg) => ({
          url: `/notifications/${arg.id}`,
          method: 'GET',
        }),
      }),
      markAsRead: build.mutation<Notification, NotificationID>({
        query: (args) => ({
          url: `/notifications/${args.id}/read`,
          method: 'PATCH',
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Notification', id: 'LIST' },
        ],
      }),
    }
  },
})

export const {
  useGetNotificationsQuery,
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useLazyGetNotificationsQuery,
  useMarkAsReadMutation,
} = notificationApi
